<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24">
    <path
      d="M16.1406 9.27368C16.1406 9.27368 18.855 11.4879 16.1406 14.7329"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      fill="none"
    />
    <path
      d="M18.3184 6.9895C18.3184 6.9895 22.8772 11.0552 18.3184 17.0107"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      fill="none"
    />
    <path
      d="M3.6543 3.63623L20.3462 19.8738"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      fill="none"
    />
    <path
      d="M13.8309 13.4221V4.32988C13.8309 4.09446 13.6413 3.90358 13.4058 3.90358C11.0315 3.89722 9.03007 5.46244 8.44141 7.59393"
    />
    <path
      d="M5.01431 8.44019C4.25559 9.00646 3.75195 9.87179 3.75195 10.8516V13.4094C3.75195 15.121 5.23669 16.5081 7.06155 16.5081H8.21925C8.3239 16.5081 8.40893 16.578 8.43509 16.6735C9.02376 18.805 11.0187 20.3702 13.3995 20.3638C13.6415 20.3638 13.8246 20.1666 13.8246 19.9375V17.0234"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconSpeakerOff',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
